import React, { useRef, useState } from 'react';

const DRAG_THRESHOLD = 8;
const SIZE = 52;

const loadSavedPos = (key) => {
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    if (
      saved &&
      Number.isFinite(saved.x) && Number.isFinite(saved.y) &&
      saved.x >= 0 && saved.y >= 0 &&
      saved.x <= window.innerWidth - SIZE &&
      saved.y <= window.innerHeight - SIZE
    ) {
      return saved;
    }
  } catch {}
  return null;
};

const DraggableFab = ({ label, className, storageKey, onAction, disabled }) => {
  const [pos, setPos] = useState(() => loadSavedPos(storageKey));
  const dragRef = useRef(null);

  const clamp = (x, y) => ({
    x: Math.min(Math.max(x, 0), window.innerWidth - SIZE),
    y: Math.min(Math.max(y, 0), window.innerHeight - SIZE),
  });

  const handlePointerDown = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      offsetX: e.clientX - rect.left,
      offsetY: e.clientY - rect.top,
      moved: false,
      lastPos: null,
    };
    e.currentTarget.setPointerCapture(e.pointerId);
  };

  const handlePointerMove = (e) => {
    const d = dragRef.current;
    if (!d) return;
    if (!d.moved) {
      if (Math.hypot(e.clientX - d.startX, e.clientY - d.startY) < DRAG_THRESHOLD) return;
      d.moved = true;
    }
    const next = clamp(e.clientX - d.offsetX, e.clientY - d.offsetY);
    d.lastPos = next;
    setPos(next);
  };

  const handlePointerUp = () => {
    const d = dragRef.current;
    dragRef.current = null;
    if (!d) return;
    if (!d.moved) {
      if (!disabled) onAction();
      return;
    }
    if (d.lastPos) {
      try { localStorage.setItem(storageKey, JSON.stringify(d.lastPos)); } catch {}
    }
  };

  const style = pos
    ? {
        position: 'fixed',
        left: pos.x,
        top: pos.y,
        right: 'auto',
        bottom: 'auto',
        touchAction: 'none',
        userSelect: 'none',
      }
    : { touchAction: 'none', userSelect: 'none' };

  return (
    <button
      type="button"
      className={className}
      style={style}
      disabled={disabled}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerCancel={() => { dragRef.current = null; }}
      onClick={(e) => e.preventDefault()}
    >
      {label}
    </button>
  );
};

export default DraggableFab;
